module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "height": _vm.calculatedHeight,
      "width": _vm.calculatedWidth
    }
  }, [_c('scrollbar', {
    attrs: {
      "viewportHeight": _vm.calculatedHeight - _vm.cornerHeight,
      "viewportWidth": _vm.calculatedWidth - _vm.cornerWidth,
      "viewportX": _vm.cornerWidth,
      "viewportY": _vm.cornerHeight,
      "contentWidth": _vm.calculatedColumnsWidth,
      "contentHeight": _vm.calculatedRowsHeight,
      "scrollReverse": _vm.scrollReverse
    },
    on: {
      "dragX": _vm.onDragX,
      "dragY": _vm.onDragY
    }
  }, [_c('g', {
    style: (_vm.dataStyle)
  }, [_vm._l((_vm.partialData), function(item) {
    return _c('rect', {
      style: (_vm.getRectStyle(item)),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      },
      on: {
        "click": function($event) {
          _vm.onCellClick($event, item)
        },
        "touchstart": function($event) {
          _vm.onCellClick($event, item)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.partialData), function(item) {
    return (_vm.bars) ? _c('rect', {
      attrs: {
        "height": item.height / 4,
        "width": item.width * (item.value / _vm.maxValue),
        "x": item.x,
        "y": item.y,
        "fill": item.value ? _vm.Theme.valueToColor(item.value, _vm.maxValue) : 'none'
      },
      on: {
        "click": function($event) {
          _vm.onCellClick($event, item)
        },
        "touchstart": function($event) {
          _vm.onCellClick($event, item)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.partialData), function(item) {
    return _c('text', {
      style: (_vm.getTextStyle(item)),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y,
        "dy": item.height / 2 + _vm.calculatedFontSize / 2,
        "dx": item.width - 5,
        "text-anchor": "end"
      },
      on: {
        "click": function($event) {
          _vm.onCellClick($event, item)
        },
        "touchstart": function($event) {
          _vm.onCellClick($event, item)
        }
      }
    }, [_vm._v(_vm._s(item.text) + "\n      ")])
  })], 2), _vm._v(" "), _c('g', {
    style: (_vm.colHeaderStyle)
  }, [_vm._l((_vm.colItems), function(item) {
    return _c('rect', {
      style: (item.rectStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    })
  }), _vm._v(" "), _vm._l((_vm.colItems), function(item) {
    return _c('foreignObject', {
      key: item.x + '_' + item.y,
      style: (item.textStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    }, [_c('div', {
      style: ({
        textAlign: 'center',
        color: _vm.Theme.headerText,
        overflow: 'hidden',
        lineHeight: _vm.cellHeight + 'px',
        userSelect: 'none',
        padding: '0 5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }),
      attrs: {
        "title": item.text
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('g', {
    style: (_vm.rowHeaderStyle)
  }, [_vm._l((_vm.rowItems), function(item) {
    return _c('rect', {
      style: (item.rectStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    })
  }), _vm._v(" "), _vm._l((_vm.rowItems), function(item) {
    return _c('foreignObject', {
      key: item.x + '_' + item.y,
      style: (item.textStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    }, [_c('div', {
      style: ({
        textAlign: 'center',
        color: _vm.Theme.headerText,
        overflow: 'hidden',
        lineHeight: _vm.cellHeight + 'px',
        userSelect: 'none',
        padding: '0 5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }),
      attrs: {
        "title": item.text
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('g', [_c('rect', {
    style: (("fill:" + (_vm.Theme.bodyPrimary) + ";stroke:" + (_vm.Theme.headerBorder))),
    attrs: {
      "height": _vm.cornerHeight,
      "width": _vm.cornerWidth
    }
  }), _vm._v(" "), _vm._l((_vm.cornerItems), function(item) {
    return _c('rect', {
      style: (item.rectStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    })
  }), _vm._v(" "), _vm._l((_vm.cornerItems), function(item) {
    return _c('foreignObject', {
      key: item.x + '_' + item.y,
      style: (item.textStyle),
      attrs: {
        "height": item.height,
        "width": item.width,
        "x": item.x,
        "y": item.y
      }
    }, [_c('div', {
      style: ({
        textAlign: item.textStyle.textAlign,
        color: item.textStyle.fill,
        overflow: 'hidden',
        lineHeight: _vm.cellHeight + 'px',
        userSelect: 'none',
        padding: item.textStyle.padding,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }),
      attrs: {
        "title": item.text
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('rect', {
    attrs: {
      "height": _vm.calculatedHeight,
      "width": _vm.calculatedWidth,
      "fill": "none",
      "stroke": _vm.Theme.headerBorder
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bce5b95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Crosstab.vue
// module id = 53
// module chunks = 0